import React from 'react';

const MakrwatchLogo = () => (
    <img src="/icons/makrwatch-logo-blue.svg" alt="Makrwatch logo" className="logo"/>
);

export default MakrwatchLogo;
